// src/volumeRegistration/containers/VolumeRegistration.js

import { connect } from 'react-redux';
import VolumeRegistrationScreen from '../components/VolumeRegistrationScreen';
import actions from '../../actions';

const mapStateToProps = (state) => ({
    // List of all contracts
    contracts: state.contract.contracts,
    // Contracts available for volume registration
    volumeContracts: state.common.volumeContracts,
    // Current username (for key derivation)
    username: state.profile.username,
    // Loading/error state for the volume registration call
    registerProductByVolumeStatus: state.volume.registerStatus,
});

const mapDispatchToProps = (dispatch) => ({
    // Fetch a single contract's details
    getContractOs: (id, cb) => dispatch(actions.contract.getContractOs(id, cb)),
    // Fetch or refresh all OS contracts
    getOSContracts: (forceReload) => dispatch(actions.common.getOSContracts(forceReload)),
    // Fetch the list used to populate the selector
    getVolumeContracts: () => dispatch(actions.common.getVolumeContracts()),
    // Perform the volume registration
    registerProductByVolume: (os, contractId, traces, cb) =>
        dispatch(
            actions.volumeRegistration.registerProductByVolume(
                os, // obra_social ID
                contractId, // contract of this registration
                traces, // array of trace objects
                cb, // successCallback
            ),
        ),
    // Clear the registration UI status
    clearVolumeRegistrationUI: () =>
        dispatch(actions.volumeRegistration.clearVolumeRegistrationUI()),
    // Clear just the error state
    clearVolumeRegistrationError: () =>
        dispatch(actions.volumeRegistration.clearVolumeRegistrationError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VolumeRegistrationScreen);
